const retrieveTimings = data => {
  const configTimings = data.timings || [];
  const timings = configTimings.reduce((entries, timing) => {
    const startMark = data.metrics.marks.find(mark => mark.name === timing.startMark);
    if (timing.startMark && !startMark) {
      return entries;
    }
    const endMark = data.metrics.marks.find(mark => mark.name === timing.endMark);
    if (timing.endMark && !endMark) {
      return entries;
    }
    if (data.metrics.startTime === null || data.metrics.endTime === null) {
      return null;
    }
    const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
    const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
    entries[`${timing.key}`] = {
      startTime,
      duration
    };
    return entries;
  }, {});
  return timings;
};
export const customTimings = data => {
  if (!data.timings) {
    return null;
  }
  const timings = retrieveTimings(data);
  if (Object.keys(timings).length === 0) {
    return null;
  }
  return timings;
};